import { useDispatch, useSelector } from "react-redux";
import { Step, IStore } from "../../DataTypes/storeTypes";
import { requestCancel } from "../../Actions/actions";
import { EnumValues } from "../../../Common/enumHelper";
import { Button } from "@powerdiary/components-library/lib";
import { useMemo } from "react";

export const StepsSummary = () => {
    const { stepsInfo } = useSelector((state: IStore) => state);
    const dispatch = useDispatch();

    const steps = useMemo(() => {
        const keys = EnumValues.getNamesAndValues(Step);

        return keys.map((k) => {
            const summary = stepsInfo[k.value];
            if (!summary || !summary.summary) {
                return null;
            }

            return (
                <div
                    key={k.value}
                    className="badge badge-default summary-badge text-wrap text-break"
                >{`${k.name}: ${summary.summary}`}</div>
            );
        });
    }, [stepsInfo]);

    return (
        <div className="row">
            <div className="col-12">
                <div className="panel">
                    <div className="panel-title">
                        <span className="text-dark-gray">Appointment Summary</span>

                        <Button variant="outlined" size="extraSmall" onClick={() => dispatch(requestCancel(true))}>
                            Cancel
                        </Button>
                    </div>
                    <div className="panel-body pt-3">{steps}</div>
                </div>
            </div>
        </div>
    );
};
